<template>
  <v-layout>
    <v-spacer></v-spacer>
    <template v-if="isLoggedIn">
      <v-btn text>Welcome {{ user.name }}!</v-btn>
      <v-btn dark to="/logout" color="primary">Logout</v-btn>
    </template>
    <template v-else>
      <v-btn text to="/register">Register</v-btn>
      <v-btn dark to="/login" color="primary">Login</v-btn>
    </template>
  </v-layout>
</template>

<script>
  export default {
    data: () => ({

    }),
    computed: {
      user() {
        return this.$store.state.user;
      },
      isLoggedIn() {
        return this.$store.state.loggedIn;
      }
    }
  };
</script>
